// ABOUTME: Full-page notice shown when a user's account is blocked after login.
// ABOUTME: Displays a locked icon, explanation text, and a logout button — no sidebar or auth layout.
import { Box, useTheme } from "@mui/material";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLogoutMutation } from "../../newapi/user/authentication/authApiSlice";
import Shbutton from "../../components/theme/buttons/Shbutton";
import Text from "../../components/theme/text/Text";
import { tokens } from "../../theme";
import Subheading from "../../components/theme/text/Subheading";

const AccountBlocked = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [logout] = useLogoutMutation();

    const handleLogout = async () => {
        await logout();
        navigate("/login");
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100],
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "32px",
                    borderRadius: "24px",
                    background: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    boxShadow: `0px 0px 19px ${colors.grey[200]}`,
                    maxWidth: 420,
                    textAlign:'center',
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 64,
                        height: 64,
                        borderRadius: "50%",
                        background: colors.red[100],
                        mb:3,
                    }}
                >
                    <LockOutlinedIcon sx={{ fontSize: 32, color: colors.red[400] }} />
                </Box>

                <Subheading textAlign="center">
                    {t("account_blocked_title")}
                </Subheading>

                <Text light center>
                    {t("account_blocked_description")}
                </Text>

                <Shbutton
                    onClick={handleLogout}
                    color="red"
                    variant="contained"
                    block
                    sx={{ mt: 3 }}
                >
                    {t("logout")}
                </Shbutton>
            </Box>
        </Box>
    );
};

export default AccountBlocked;
